/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISecretsResolver } from "@adapptio/lib-blueprint";

export class SecretsEditorResolver implements ISecretsResolver {
	/**
	 * Returns secret
	 */
	public getSecret(): string {
		return null;
	}
}
